module.exports = __webpack_public_path__ + "static/img/bg-ar.43804471.png";